module.exports = __webpack_public_path__ + "img/medical.0b0678b0.jpg";